import TranslatableText from "../../../components/translations/TranslatableText";
import Pagination from "../../../components/pagination/Pagination";

interface ProjectPaginationProps {
  projectsCount: number;
  isLoading: boolean;
  itemsPerPage: number;
  onNext: () => void;
  onPrevious: () => void;
  onPageClick: (page: number) => void;
}

const ProjectPagination = ({
  projectsCount,
  isLoading,
  itemsPerPage,
  onNext,
  onPrevious,
  onPageClick,
}: ProjectPaginationProps) => {
  if (projectsCount && projectsCount > itemsPerPage) {
    return (
      <Pagination
        totalItems={projectsCount}
        onNext={onNext}
        onPrevious={onPrevious}
        onPageClick={onPageClick}
        itemsPerPage={itemsPerPage}
        size="sm"
      />
    );
  }

  if (projectsCount === 0 && !isLoading) {
    return (
      <div style={{ height: "5rem" }} className="w-100 d-flex align-items-center justify-content-center bg-white">
        <TranslatableText translationKey="project.no_projects_yet" className="ff-medium" />
      </div>
    );
  }

  return null;
};

export default ProjectPagination; 